export default __webpack_public_path__ + "static/media/Password-Generator.06e0700c.jpg";